import { render } from "./ThanksPage.vue?vue&type=template&id=30abaa2d&scoped=true"
import script from "./ThanksPage.vue?vue&type=script&lang=js"
export * from "./ThanksPage.vue?vue&type=script&lang=js"

import "./ThanksPage.vue?vue&type=style&index=0&id=30abaa2d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30abaa2d"]])

export default __exports__